import { createThemeCompiler } from '../../../utils';

export const compactTimePickerThemeCompiler = createThemeCompiler(({ palette }) => ({
    compactTimePicker: {
        colors: {
            default: {
                listViewItemBackgroundColor: palette.white,
                listViewItemTextColor: palette.black
            },
            disabled: {
                listViewItemBackgroundColor: palette.neutralLight,
                listViewItemTextColor: palette.neutralSecondaryAlt
            },
            focussed: {
                listViewItemBackgroundColor: palette.themeLighterAlt,
                listViewItemTextColor: palette.themeLight
            },
            hovered: {
                listViewItemBackgroundColor: palette.themeLighterAlt,
                listViewItemTextColor: palette.themeLight
            },
            selected: {
                listViewItemBackgroundColor: palette.themeLight,
                listViewItemTextColor: palette.themeLighterAlt
            }
        },
        composites: {}
    }
}));
